var map = {
	"./dangerous.mp4": 38,
	"./free.mp4": 147,
	"./glimpse-of-us.mp4": 407,
	"./goose.mp4": 418,
	"./icronic.mp4": 784,
	"./jdsc.mp4": 379,
	"./let-me-down-slowly.mp4": 685,
	"./touch.mp4": 455,
	"./yourIdol.mp4": 574
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 650;